import styled from 'styled-components';

import { flexStart } from '../../../style/reusableStyle';

export const PrinterDetailsContainerStyled = styled.div`
  margin-top: 18px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 30px 20px;

  & .container {
    margin-left: 30px;
  }

  & .uploadedLogo {
    display: flex;
    flex-wrap: wrap;
  }
  & .heading {
    margin-left: 24px;
    ${flexStart};
    gap: 150px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    & .heading {
      margin: 0px;
      font-size: 14px;
    }
    & .title,
    .value {
      font-size: 12px;
      line-height: 1.5;
    }
    & .jobInformation {
      display: flex;
      flex-direction: row;
    }
  }
`;
